import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

const Container = styled.div`
  min-height: 128px;
  min-width: 154px;
  height: 155px;
  width: 48%;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 10px 0;
`

const CircleDiv = styled.div`
  width: 64px;
  height: 64px;
  margin: 0 6px 14px;
  border: solid 3px #ffcf86;
  background-color: #000;
  border-radius: 50%;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  font-family: "Bebas Neue", cursive;
`

const Title = styled.p`
  font-family: "montserratLight";
  margin: 0;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #dfe4ff;
`

const StatsCard = ({ stats, title, theme }) => {
  return (
    <Container style={{ backgroundColor: theme.cardColor }}>
      <CircleDiv>{stats}</CircleDiv>
      <Title>{title}</Title>
    </Container>
  )
}

export default StatsCard



// WEBPACK FOOTER //
// ./src/components/Stats/statsCard/StatsCard.js